import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, MapPin, Github, Twitter, Linkedin } from 'lucide-react';
import { useLang } from '../i18n/LangContext';

const Footer = () => {
  const { t } = useLang();

  return (
    <footer data-testid="site-footer" className="relative mt-32 border-t border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-blue-600 flex items-center justify-center">
              <span className="heading-font font-black text-white text-lg">L</span>
            </div>
            <span className="heading-font font-extrabold text-white text-xl">
              lyomas<span className="text-blue-500">tech</span>
            </span>
          </Link>
          <p className="mt-5 text-zinc-400 max-w-md leading-relaxed">{t('footer.tagline')}</p>
          <div className="mt-6 flex gap-3">
            {[Github, Twitter, Linkedin].map((Icon, i) => (
              <motion.a
                key={i}
                whileHover={{ y: -3 }}
                href="#"
                data-testid={`social-link-${i}`}
                className="w-10 h-10 grid place-items-center rounded-md border border-white/10 hover:border-blue-500 hover:text-blue-400 text-zinc-400 transition"
                aria-label="social"
              >
                <Icon className="w-4 h-4" />
              </motion.a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="heading-font text-sm uppercase tracking-[0.2em] text-zinc-500 mb-4">
            {t('footer.explore')}
          </h4>
          <ul className="space-y-3 text-zinc-300">
            <li><Link to="/services" className="hover:text-blue-400 transition">{t('nav.services')}</Link></li>
            <li><Link to="/portfolio" className="hover:text-blue-400 transition">{t('nav.portfolio')}</Link></li>
            <li><Link to="/about" className="hover:text-blue-400 transition">{t('nav.about')}</Link></li>
            <li><Link to="/contact" className="hover:text-blue-400 transition">{t('nav.contact')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="heading-font text-sm uppercase tracking-[0.2em] text-zinc-500 mb-4">
            {t('footer.contact')}
          </h4>
          <ul className="space-y-3 text-zinc-300">
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-1 text-blue-500 shrink-0" />
              <a href="mailto:lyomastech@gmail.com" className="hover:text-blue-400" data-testid="footer-email">
                lyomastech@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1 text-blue-500 shrink-0" />
              <span>Cairo, Egypt</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-zinc-500">
          <p>© {new Date().getFullYear()} lyomastech. {t('footer.rights')}</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition">{t('footer.privacy')}</a>
            <a href="#" className="hover:text-white transition">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
